const ConnectionStatus = {
  Unknown: 'unknown',
  DisconnectedIntentional: 'disconnected_intentional',
  Active: 'active',
  CheckingConnection: 'checking_connection',
  isActive: (status) =>
    status === ConnectionStatus.Active ||
    status === ConnectionStatus.CheckingConnection,
};
export default ConnectionStatus;
